// import router from '../router';
import helpers from '../helpers';

const modalToArrayEntries = window.data.modals ? Object.entries(window.data.modals) : false;

function setContent(id, $body, modalID = false) {
	return new Promise((resolve) => {
		let content;

		if (modalToArrayEntries) {
			content = modalID ? window.data.modals[modalID] : window.data.modals[id];
		}

		let html = '';

		if (id === 'pass') {
			html = `
			<div class="modal__row">
				<div class="modal__media js-modal-slider">
					<picture class="modal__picture"><img class="image" draggable="false" src="${window.baseDir}images/modal/pass-1.jpg" alt="Изображение офиса автодор 1" srcset="${window.baseDir}images/modal/pass-1@2x.jpg 2x"></picture>
					<picture class="modal__picture"><img class="image" draggable="false" src="${window.baseDir}images/modal/pass-2.jpg" alt="Изображение офиса автодор 2" srcset="${window.baseDir}images/modal/pass-2@2x.jpg 2x"></picture>
					<picture class="modal__picture"><img class="image" draggable="false" src="${window.baseDir}images/modal/pass-3.jpg" alt="Изображение офиса автодор 3"></picture>
				</div>
				<div class="modal__content">
					<h2 class="modal__title"><span>Центры поддержки и&nbsp;обслуживания пользователей</span><img class="modal__transponder" draggable="false" src="${window.baseDir}images/modal/pass.png" srcset="${window.baseDir}images/modal/pass@2x.png 2x" alt="Карточка транспондер">
					</h2>
					<p class="modal__text">В&nbsp;Центрах поддержки и&nbsp;обслуживания пользователей можно получить подробную консультацию по&nbsp;оплате проезда на&nbsp;ЦКАД, приобрести электронный билет, погасить задолженность или купить транспондер <nobr>T-pass</nobr>&nbsp;&mdash; устройство, позволяющее экономить до&nbsp;40% на&nbsp;ЦКАД и&nbsp;до&nbsp;76% на&nbsp;других платных дорогах, находящихся в&nbsp;доверительном управлении Государственной компании &laquo;Автодор&raquo;. Специалисты центров познакомят с&nbsp;ассортиментом устройств, подскажут, как завести личный кабинет владельца транспондера <nobr>T-pass</nobr>, помогут подключить интероперабельность (для использования транспондера на&nbsp;платных дорогах других эмитентов), пополнят баланс лицевого счета.</p>
					<h4 class="modal__subtitle">На&nbsp;самой ЦКАД находятся пять Центров поддержки и&nbsp;обслуживания пользователей:</h4>
					<ul class="modal__list">
						<li>2&nbsp;км ЦКАД (с&nbsp;09:00 до&nbsp;21:00)</li>
						<li>55&nbsp;км ЦКАД (с&nbsp;09:00 до&nbsp;21:00)</li>
						<li>99&nbsp;км ЦКАД (с&nbsp;09:00 до&nbsp;21:00)</li>
						<li>180&nbsp;км ЦКАД (скоро открытие)</li>
						<li>210&nbsp;км ЦКАД (скоро открытие)</li>
					</ul>
					<h4 class="modal__subtitle">Также открыты дополнительные офисы:</h4>
					<ul class="modal__list">
						<li>г. Ногинск, ул. Поселковая, д.72, ТЦ&nbsp;&laquo;Панорама&raquo; (с&nbsp;09:00-21:00 ежедневно)</li>
						<li>г. Бронницы, ул. Льва Толстого, д.9, ТД&nbsp;&laquo;Кэмп Стиль&raquo; (понедельник&nbsp;&mdash; четверг 09:00-18:00, пятница 09:00-16:45, выходные дни: суббота&nbsp;&mdash; воскресенье)</li>
						<li>г. Москва, ул. Ленинская Слобода, д.&nbsp;26, стр.&nbsp;28&nbsp;(бизнес-центр &laquo;Слободской&raquo;), 1-й этаж, офис &#8470;&nbsp;142 (с&nbsp;09:00-21:00&nbsp;ежедневно)</li>
					</ul>
					<p class="modal__text">Консультацию по&nbsp;вопросам пользования ЦКАД и&nbsp;транспондеров <nobr>T-pass</nobr> можно получить в&nbsp;любом офисе и&nbsp;Центре продаж и&nbsp;обслуживания ООО&nbsp;&laquo;Автодор&nbsp;&mdash; Платные Дороги&raquo;, которые расположены вдоль платных автодорог и&nbsp;круглосуточно по&nbsp;телефону Единого контактного центра *2323.</p>
				</div>
			</div>
			<div class="modal__buttons">
				<a class="modal__button btn" href="https://www.avtovzglyad.ru/promo/ckad-vokrug-moskvy-s-veterkom/" target="_blank">
					<span>Перейти в&nbsp;спецпроект</span>
					<svg><use xlink:href="images/sprites.svg#arrow-right"></use></svg>
				</a>
				<a class="modal__button btn" href="https://avtodor-tr.ru/ru/ckad/?utm_source=avtovzglyad.ru&utm_medium=open&utm_compaign=ckad" target="_blank">
					<span>Узнать больше</span>
					<svg><use xlink:href="images/sprites.svg#arrow-right"></use></svg>
				</a>
			</div>
		`;
		} else if (id === 'frame') {
			const table = content && content.table ? `
				<div class="modal__table">
					<h3 class="modal__table-title">${content.tableTitle}</h3>
					<div class="modal__table-container">
						<div class="modal__table-head">
							<div class="modal__table-row">
								<div class="modal__table-cell">Стоимость проезда, руб</div>
								<div class="modal__table-cell">
									<img src="${window.baseDir}images/modal/table-1.png" alt="таблица цен транспондера" srcset="${window.baseDir}images/modal/table-1@2x.png 2x">
								</div>
								<div class="modal__table-cell">
									<img src="${window.baseDir}images/modal/table-2.png" alt="таблица цен транспондера" srcset="${window.baseDir}images/modal/table-2@2x.png 2x">
								</div>
							</div>
						</div>
						<div class="modal__table-body">
							${content.table.map((item) => {
		return `<div class="modal__table-row">
									<div class="modal__table-cell">
										<p>${item.text}</p>
										<div class="modal__table-hint">${item.hint}</div>
									</div>
									<div class="modal__table-cell">${item.price1}</div>
									<div class="modal__table-cell">${item.price2}</div>
								</div>`;
	}).join('')}
						</div>
					</div>
				</div>
			` : null;

			html = `
				<div class="modal__row">
					<div class="modal__media">
						<picture class="modal__picture">
							<img class="image" draggable="false" src="${window.baseDir}images/modal/${content && content.image ? content.image : 'frame@2x'}.jpg" alt="Изображение рамки ЦКАД">
						</picture>
						${table !== undefined && table !== null ? table : ''}
					</div>
					<div class="modal__content">
						<h2 class="modal__title">Рамки <br>«Свободный поток»</h2>
						<p class="modal__text">На Центральной кольцевой автомобильной дороге внедрена принципиально новая система взимания платы «Свободный поток». На протяжении всей дороги установлены П-образные опоры с камерами, датчиками и антеннами, позволившими отказаться от привычных пунктов взимания платы со шлагбаумами. Теперь оплата производится без остановок с лицевого счета пользователя по транспондеру или с помощью регистрации проезда по государственным регистрационным номерным знаков транспортных средств.</p>
						<p class="modal__text">Сделать проезд максимально выгодным и уберечь от штрафов за неоплату проезда поможет транспондер <nobr>T-pass</nobr>. Компактное устройство, скидки на проезд от основного тарифа по которому достигают 40%. Благодаря транспондеру <nobr>T-pass</nobr> нет необходимости приобретать электронный билет заранее или отслеживать задолженность после поездки по госномеру автомобиля.</p>
						<p class="modal__text">Да, такие варианты тоже предусмотрены в случае отсутствия транспондера <nobr>T-pass</nobr> необходимо купить электронный билет на сайте компании<a href="https://avtodor-tr.ru/ru/ckad/" target="_blank"><span>«Автодор-Платные Дороги»</span> <svg><use xlink:href="images/sprites.svg#arrow-right"></use></svg></a>в<a href="http://www.onelink.to/kbu77r" target="_blank"><span>мобильном приложении «Автодор»</span> <svg><use xlink:href="images/sprites.svg#arrow-right"></use></svg></a>, терминалах «Элекснет» и&nbsp;МКБ или в Центрах поддержки и обслуживания. Что же касается безбилетного проезда, то срок погашения задолженности без штрафа за&nbsp;проезд по госномеру транспортного средства составляет 5 дней. Но&nbsp;нужно помнить существенное условие, что при покупке разового билета и при погашении задолженности никаких скидок на проезд не предусмотрено. Да и по программе лояльности, как у транспондера <nobr>T-pass</nobr>, получить дополнительные скидки до 15% точно не придется!</p>
						<a class="modal__transponder modal__transponder--footer" href="https://tpass.me/" target="_blank"><img class="image js-lazy" draggable="false" src="${window.baseDir}images/transponder.png" alt="АвтоВзгляд" srcset="${window.baseDir}images/transponder@2x.png 2x"></a>
					</div>
				</div>
				<div class="modal__buttons">
					<a class="modal__button btn" href="https://tpass.me/trassy/ckad/" target="_blank">
						<span>Рассчитать проезд</span>
						<svg><use xlink:href="images/sprites.svg#arrow-right"></use></svg>
					</a>
					<a class="modal__button btn" href="https://tpass.me/shop/" target="_blank">
						<span>Купить транспондер</span>
						<svg><use xlink:href="images/sprites.svg#arrow-right"></use></svg>
					</a>
				</div>
			`;
		} else if (id === 'interchange') {
			html = `
			<div class="modal__row">
				<div class="modal__media js-modal-slider">
					<picture class="modal__picture modal__picture--map">
						<img class="image" draggable="false" src="${window.baseDir}images/popups/${modalID ? modalID : id}.png" alt="${content.title}">
					</picture>
					${content && content.slider ? `
						${content.slider.map((item) => {
		return `
							<div class="modal__slider-item">
								<img draggable="false" src="${window.baseDir}images/modal-slider/${item.src}.jpg" alt="Изображение развязок">
							</div>`;
	}).join('')}` : ''}
					${content && content.video ? `<div class="modal__video js-modal-video">
						<video poster="${window.baseDir}video/${content.video}.jpg" src="${window.baseDir}video/${content.video}.mp4" type="video/mp4"></video>
					</div>` : ''}
				</div>
				<div class="modal__content">
					<h2 class="modal__title modal__title--big">${content.title}</h2>
					<p class="modal__text">${content.text}</p>
					<blockqoute class="modal__blockqoute">Оплатить проезд по&nbsp;ЦКАД можно одним из&nbsp;трех способов: с&nbsp;помощью транспондера <nobr>T-pass</nobr>, который позволяет экономить до&nbsp;40% от&nbsp;стоимости поездки, приобретенного заранее электронного билета на&nbsp;разовый проезд или путем погашения задолженности уже после проезда. Однако важно помнить, что в&nbsp;последнем случае необходимо внести средства в&nbsp;течение пяти календарных дней. Водителям, не&nbsp;рассчитавшимся за&nbsp;проезд, выписывается штраф в&nbsp;размере 1500 рублей для легкового автомобиля и&nbsp;5000 рублей&nbsp;&mdash; для грузового (ст.&nbsp;12.21.4. КоАП&nbsp;РФ).</blockqoute>
				</div>
			</div>
			<div class="modal__buttons">
				<a class="modal__button btn" href="https://www.avtovzglyad.ru/promo/ckad-vokrug-moskvy-s-veterkom/" target="_blank">
					<span>Перейти в&nbsp;спецпроект</span>
					<svg><use xlink:href="images/sprites.svg#arrow-right"></use></svg>
				</a>
				<a class="modal__button btn" href="https://avtodor-tr.ru/ru/ckad/?utm_source=avtovzglyad.ru&utm_medium=open&utm_compaign=ckad" target="_blank">
					<span>Узнать больше</span>
					<svg><use xlink:href="images/sprites.svg#arrow-right"></use></svg>
				</a>
			</div>
		`;
		}

		$body.html(html);

		resolve();
	});
}

function sliderInit($container) {
	$container.slick({
		rows: 0,
		dots: true,
		fade: true,
		adaptiveHeight: true,
	});

	$container.on('beforeChange', () => {
		if ($container.find('video').length) {
			$container.find('video').get(0).pause();
		}
	});
}

function open(id, modalID) {
	const $modal = $('.modal');
	const $body = $modal.find('.modal__body');
	const $scroller = $modal.find('.modal__scroller');

	let prevId;
	let nextId;

	setContent(id, $body, modalID).then(() => {
		gsap.from($modal, {
			autoAlpha: 0,
			x: '100%',
			clearProps: 'all',
			onStart() {
				$modal.removeClass('is-hidden');
				$modal.attr('aria-hidden', false);
				$scroller[0].scrollTop = 0;

				setTimeout(() => {
					helpers.lockScroll(true, $scroller, 'modal');
					helpers.$body.css('padding-right', `${helpers.getScrollbarWidth()}px`);
					helpers.$header.css('right', `${helpers.getScrollbarWidth()}px`);
				}, 50);
			},
			onComplete() {
				$modal.addClass('is-active');
				helpers.$html.data('modal', id);

				if ($('[class*="is-browser-firefox"]').length) {
					$scroller.css('padding-right', `${helpers.getScrollbarWidth()}px`);
				}

				if ($body.find('.js-modal-slider').length) {
					sliderInit($body.find('.js-modal-slider'));
				}

				if ($body.find('.js-modal-video').length) {
					objectFitVideos();

					$('.js-modal-video').on('click.modal', (e) => {
						if ($(e.currentTarget).hasClass('is-playing')) {
							$(e.currentTarget).removeClass('is-playing');
							$(e.currentTarget).find('video').get(0).pause();
						} else {
							$(e.currentTarget).addClass('is-playing');
							$(e.currentTarget).find('video').get(0).play();
						}
					});
				}
			},
		});
	});

	for (let i = 0; i < modalToArrayEntries.length; i++) {
		const element = modalToArrayEntries[i];

		if (element[0] === id) {
			// eslint-disable-next-line no-nested-ternary
			prevId = i - 1 >= 0 ? i - 1 : modalToArrayEntries.length - 1;
			nextId = i + 1 < modalToArrayEntries.length ? i + 1 : 0;
		}
	}

	$('.js-modal-arrow-prev').data('target', prevId);
	$('.js-modal-arrow-next').data('target', nextId);
}

function close() {
	helpers.$html.removeAttr('data-modal');

	const $modal = $('.modal');
	const $body = $modal.find('.modal__body');
	$modal.attr('aria-hidden', true);

	gsap.to($body, {
		autoAlpha: 0,
		x: '100%',
		clearProps: 'all',
		onComplete() {
			$modal.removeClass('is-active');
			$modal.addClass('is-hidden');

			if ($body.find('.js-modal-video').length) {
				$('.js-modal-video').off('.modal');
				$('.js-modal-video video').get(0).pause();
			}

			$body.html('');

			helpers.$body.css('padding-right', '');
			helpers.$header.css('right', '');
			$modal.css('padding-right', '');
			helpers.lockScroll(false, $modal.find('.modal__scroller'), 'modal');
		},
	});
}

function init() {
	helpers.$document.on('click.popup', '.js-modal-open', (e) => {
		e.preventDefault();
		e.stopPropagation();

		const id = $(e.currentTarget).data('modal');
		const modal = $(e.currentTarget).data('modal-id');

		open(id, modal);
	});

	$('.js-modal-close').on('click.modal', (e) => {
		e.preventDefault();

		close();
	});

	$('.modal__scroller').on('click.modal', (e) => {
		if (!e.target.nodeName === 'A') {
			e.preventDefault();
		}
		const container = e.currentTarget.querySelector('.modal__article');

		if (e.target !== container && !container.contains(e.target)) {
			close();
		}
	});

	helpers.$document.on('keyup.modal', (e) => {
		if (helpers.$html.data('modal') && (e.key === 'Escape' || e.key === 'Esc')) {
			close();
		}
	});
}

export default {
	init,
	open,
	close,
};
